import React, { useState } from "react";
import { FaHospitalUser } from "react-icons/fa";

const DEFAULT_DATA = {
	total: 3723,
	lastMonth: 3490, // last month value
};

export default function SAMCard({ selectedDistrict = null }) {
	const [open, setOpen] = useState(false);

	const data = selectedDistrict
		? {
			total: Math.round(DEFAULT_DATA.total * 0.2),
			lastMonth: Math.round(DEFAULT_DATA.lastMonth * 0.2),
		}
		: DEFAULT_DATA;

	// Calculate comparison
	const diff = data.total - data.lastMonth;
	const percent = ((diff / data.lastMonth) * 100).toFixed(1);
	const isUp = diff >= 0;

	return (
		<>
			{/* Small card */}
			<button
				onClick={() => setOpen(true)}
				className="inline-flex items-center gap-3 px-3 py-2 rounded-lg shadow-sm bg-white border hover:shadow-md w-full"
			>
				<div className="w-10 h-10 flex items-center justify-center rounded-md bg-red-100">
					<FaHospitalUser className="text-red-600 w-5 h-5" />
				</div>

				<div className="text-left">
					<div className="text-xs text-slate-600 font-medium">SAM Children Admitted</div>

					{/* MAIN NUMBER */}
					<div className="text-lg font-semibold">
						{data.total.toLocaleString()}
					</div>

					{/* EXACT SAME STYLE YOU SENT */}
					<div className="text-[11px]">
						<span className={isUp ? "text-green-600" : "text-red-600"}>
							{isUp ? "▲" : "▼"} {Math.abs(percent)}%
						</span>
						<span className="text-slate-500"> vs last month</span>
					</div>
				</div>
			</button>

			{/* Offcanvas */}
			{open && (
				<div className="fixed inset-0 z-50 flex">
					<div
						className="absolute inset-0 bg-black/40"
						onClick={() => setOpen(false)}
						aria-hidden
					/>

					<aside className="relative ml-auto w-full max-w-md h-full bg-white shadow-2xl overflow-auto">
						<div className="p-4 border-b flex items-center justify-between">
							<h3 className="text-lg font-semibold">Sick SAM Children Admitted</h3>
							<button
								onClick={() => setOpen(false)}
								className="px-3 py-1 rounded bg-slate-100 text-sm"
							>
								Close
							</button>
						</div>

						<div className="p-4 space-y-4">
							<div className="flex items-center gap-3">
								<div className="w-10 h-10 flex items-center justify-center rounded-md bg-red-100">
									<FaHospitalUser className="text-red-600 w-5 h-5" />
								</div>

								<div className="flex-1">
									<div className="text-sm font-medium">Total SAM Children Admitted</div>

									<div className="text-lg font-semibold">
										{data.total.toLocaleString()}
									</div>

									{/* SAME COMPARISON INSIDE PANEL */}
									<div className="text-[11px] text-slate-500">
										{isUp ? "▲" : "▼"} {Math.abs(percent)}% vs last month
									</div>
								</div>
							</div>

							<div className="mt-2 text-sm text-slate-500">
								Source: HMIS-Apr24 to Mar25
							</div>
						</div>
					</aside>
				</div>
			)}
		</>
	);
}
